"use strict";
import axios from "axios";
import Vue from "vue";
import OSS from "ali-oss";
let vm = new Vue();

export default {
  aliyunOssToken: {
    accessKeyId: "",
    policy: "",
    signature: "",
    key: "",
    expire: "",
    host: "",
    secure: true,
  },
  /**
   * 创建随机字符串
   * @param num
   * @returns {string}
   */
  randomString(num) {
    let chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let res = "";
    for (let i = 0; i < num; i++) {
      var id = Math.ceil(Math.random() * 9);
      res += chars[id];
    }
    return res;
  },
  //获取上传通行证
  getOssToken(key) {
    return new Promise((resolve, reject) => {
      var _self = this;
      vm.$httpAuth
        .post("/v2/appBaseService/aliUploadParams", {
          key: key,
          isAudio: false,
        })
        .then((res) => {
          if (res.data) {
            _self.aliyunOssToken = res.data;
            resolve(_self.aliyunOssToken);
          } else {
            _self.$message.error(res.data.message);
          }
        });
    });
  },
  /**
   * 文件上传
   * @param option 参考csdn: https://blog.csdn.net/qq_27626333/article/details/81463139
   */
  async ossUploadFile(option) {
    let file = option.file;
    const _self = this;
    let extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
    let prefixPath = "z-dealer-web/" + new Date().getTime() + extensionName;
    await this.getOssToken(prefixPath);
    var formData = new FormData();
    formData.append("key", prefixPath); //存储在oss的文件路径
    formData.append("OSSAccessKeyId", _self.aliyunOssToken.accesskeyId); //accessKeyId
    formData.append("policy", _self.aliyunOssToken.policy); //policy
    formData.append("Signature", _self.aliyunOssToken.signature); //签名

    formData.append("file", file);
    formData.append("success_action_status", 200); //成功后返回的操作码
    var url = _self.aliyunOssToken.host;
    var fileUrl = _self.aliyunOssToken.host + "/" + prefixPath;
    const config = {
      onUploadProgress: progressEvent => {
        // progressEvent.loaded:已上传文件大小
        // progressEvent.total:被上传文件的总大小
        // this.progressPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2))
        option.onProgress(progressEvent, file)
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, config)
        .then((res) => {
          //接口成功调用params上的onSuccess函数，会触发默认的successHandler函数
          //这样可以用自带的ui等
          option.onSuccess(fileUrl);
          resolve(fileUrl);
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            option.onError(
              "文件上传失败(" +
                error.response.status +
                ")，" +
                error.response.data
            );
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            option.onError("文件上传失败，服务器端无响应");
          } else {
            // Something happened in setting up the request that triggered an Error
            option.onError("文件上传失败，请求封装失败");
          }
        });
    });
  },
};
